var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_38646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13928 7.3248H5.13916H4.56576C4.42322 7.3248 4.34362 7.48902 4.43162 7.60064L4.43166 7.60068L6.6785 10.4472L6.67853 10.4472C6.82573 10.6335 7.10798 10.633 7.25567 10.4475L7.25596 10.4472L11.2618 5.37098C11.2619 5.37083 11.262 5.37067 11.2622 5.37051C11.3518 5.25821 11.2689 5.0952 11.1283 5.0952H10.5549C10.4426 5.0952 10.3357 5.14663 10.2664 5.23545C10.2663 5.23555 10.2662 5.23564 10.2661 5.23574L6.96682 9.41529L5.42754 7.46491L5.34505 7.52988L5.42748 7.46483L5.42754 7.46491C5.39319 7.4213 5.34941 7.38604 5.29949 7.36178C5.24957 7.33751 5.19479 7.32487 5.13928 7.3248Z",
    fill: "#004739",
    stroke: "#004739",
    strokeWidth: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z",
    stroke: "#004739",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_38646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.1e2322750ff5c79fece154ae28fe3645.svg";
export { ForwardRef as ReactComponent };